'use es6';

export var INPUT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__control--small'
};
export var USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};